// Мультибрендинг клиентского портала: определяем бренд по hostname.
// globus.cloudgps.online → СКТ «Глобус» (legacy)
// client.cloudgps.online и любой другой хост → cloudGPS (дефолтный SaaS-бренд)
//
// На прод-доменах решение принимаем по началу hostname'а: только хост,
// начинающийся с "globus.", считается Globus-бредом. Локальный dev (localhost)
// и любые новые домены автоматически попадают в cloudGPS — это позитивная
// фолбэк-логика: добавляем новый домен → не надо ничего править в коде.

import { getWlBrand } from '../services/brandingService'

const BRANDS = {
  globus: {
    id: 'globus',
    name: 'СКТ «Глобус»',
    shortName: 'СКТ Глобус',
    tagline: null, // используется значение из i18n (brand.tagline)
    logo: '/icons/icon.svg',
    favicon: '/icons/favicon-32.png',
    appleTouchIcon: '/icons/apple-touch-icon.png',
    manifest: '/manifest.webmanifest',
    appleTitle: 'FMS Globus',
  },
  cloudgps: {
    id: 'cloudgps',
    name: 'cloudGPS',
    shortName: 'cloudGPS',
    tagline: null,
    logo: '/icons/logo-cloudgps.webp',
    favicon: '/icons/favicon-cloudgps-32.png',
    appleTouchIcon: '/icons/favicon-cloudgps-192.png',
    manifest: '/manifest-cloudgps.webmanifest',
    appleTitle: 'cloudGPS',
  },
}

export function detectBrandId(hostname = '') {
  const host = String(hostname || '').toLowerCase()
  // Только legacy-домен globus.* остаётся под брендом «Глобус».
  // Всё остальное (client.*, dev, новые домены) — cloudGPS.
  if (host.startsWith('globus.')) return 'globus'
  return 'cloudgps'
}

export function getBrand() {
  // White label: на партнёрском домене бренд приходит с сервера
  // (services/brandingService, резолв по Host). Форма объекта совместима
  // с BRANDS — потребители (i18n, App.vue) разницы не видят.
  const wl = getWlBrand()
  if (wl) {
    return {
      ...BRANDS.cloudgps,
      id: 'wl',
      name: wl.name,
      shortName: wl.shortName,
      appleTitle: wl.name,
      logo: wl.logo || BRANDS.cloudgps.logo,
    }
  }
  const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
  const id = detectBrandId(hostname)
  return BRANDS[id]
}

export function isGlobusBrand() {
  return getBrand().id === 'globus'
}

export function isCloudGpsBrand() {
  return getBrand().id === 'cloudgps'
}
